// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bi_main[data-v-eeed33aa]{height:calc(100vh - 3.5rem - 35px);position:absolute;right:.2rem;top:6rem}.statistics_iframe[data-v-eeed33aa]{width:calc(100vw - 15.4rem);height:calc(100vh - 3.5rem - 40px)}", ""]);
// Exports
module.exports = exports;
